/*
 * @Author: 王琪瑞
 * @Date: 2021-03-15 15:29:05
 * @LastEditTime: 2021-03-15 16:21:06
 * @LastEditors: 王琪瑞
 */
import { ref, reactive } from 'vue';
import backToTeacherHome from '@/lib/backToTeacherHome';
import { Router } from 'vue-router';
import { ManagementFrameTitleItem } from '@/components/ui/managementFrame/js/types';

const experimentTitleListBase: ManagementFrameTitleItem[] = [
  { name: '分配实验' },
  { name: '分配日志' },
];

export default (router: Router) => {
  const tabIndex = ref(true); // tab栏显示状态
  const titleList = reactive(experimentTitleListBase);

  const handleBackClick = () => backToTeacherHome(router);

  const handleTagClick = async (index: number) => {
    // if (teacherModule.list.length === 0) {
    //   await teacherModule.query({ pageNo: 1, pageSize: 12 });
    // }
    tabIndex.value = index === 0;
  };

  return {
    titleList,
    tabIndex,
    handleBackClick,
    handleTagClick,
  };
};
